/** Remembers (per browser) that someone has signed in before, so auth walls can show log-in vs sign-up first. */
const KEY = 'cfa_has_account_v1';

export function rememberSignedIn(user) {
  if (!user?.uid) return;
  try {
    if (typeof window !== 'undefined') window.localStorage.setItem(KEY, '1');
  } catch {
    /* private mode / SSR */
  }
}

export function hasSignedInBefore() {
  try {
    if (typeof window === 'undefined') return false;
    return window.localStorage.getItem(KEY) === '1';
  } catch {
    return false;
  }
}

/**
 * Auth wall URL for free Mock 1 CTAs / gates.
 * Brand-new browsers → sign-up; returning (flag set) → log-in.
 * Always preserves `next` and `intent=mock`.
 */
export function mockAuthHref(nextPath = '/quiz/session-1') {
  const page = hasSignedInBefore() ? 'login' : 'signup';
  const next = String(nextPath || '/quiz/session-1');
  return `/${page}?next=${encodeURIComponent(next)}&intent=mock`;
}

/**
 * True when `path` is the L1 free Mock Exam 1 route (guest-enabled server-side).
 * Accepts optional trailing slash and/or query/hash (utm params, etc.).
 * L2/L3 and other mocks stay auth-walled.
 */
export function isL1GuestMockPath(path = '') {
  const pathname = String(path || '')
    .split(/[?#]/)[0]
    .replace(/\/+$/, '');
  return pathname === '/quiz/session-1';
}
